import { Typography } from '@material-ui/core';
import { Box,
    DialogTitle as MuiDialogTitle, IconButton,
    TextField as MuiTextField } from '@mui/material';
import { styled } from '@mui/system';

import { colors } from '../../../../theme';

export const dialogPaperProps = {
    style: {
        backgroundColor: colors.darkBlue,
        color: colors.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '600px'
    }
};

export const DialogTitle = styled(MuiDialogTitle)({
    textAlign: 'center',
    fontWeight: 'bold'
});

export const BlockerTextField = styled(MuiTextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: colors.darkBlue,
        borderRadius: '8px',
        color: colors.white,
        fontSize: '14px',
        '& fieldset': {
            borderColor: colors.darkGray
        },
        '&:hover fieldset': {
            borderColor: colors.hitGray
        },
        '&.Mui-focused fieldset': {
            borderColor: colors.lightningYellow
        }
    },
    '& .MuiInputBase-input': {
        color: colors.white,
        fontSize: '14px'
    },
    '& .MuiInputBase-input::placeholder': {
        color: colors.lightGray,
        opacity: 0.8
    }
});

export const BlockerDialogContent = styled(Box)({
    paddingTop: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
});

export const BlockerDialogButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '20px',
    width: '100%',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const AttachmentUploadWrapper = styled(Box)({
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '& > div': {
        width: '100% !important',
        maxWidth: '100% !important',
        boxSizing: 'border-box',
        paddingLeft: '0px !important'
    },
    '& label': {
        maxWidth: '100% !important',
        width: '100% !important',
        paddingLeft: '0px !important'
    },
    '& *': {
        maxWidth: '100%',
        boxSizing: 'border-box'
    }
});

export const BlockerDialogCloseButton = styled(IconButton)({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: colors.white,
    '&:hover': {
        backgroundColor: colors.darkGray
    }
});

export const AttachmentsContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '150px',
    overflowY: 'auto',
    width: '100%',
    padding: '8px 0'
});

export const AttachmentIconButton = styled(Box)({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '4px',
    marginRight: '4px'
});

export const ErrorMessage = styled(Box)({
    color: colors.errorRed,
    fontSize: '12px',
    width: '100%'
});

export const HiddenFileInput = styled('input')({
    display: 'none'
});

export const UploadProgressContainer = styled(Box)({
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%'
});

export const UploadProgressItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '8px'
});

export const UploadProgressFileInfo = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    width: '160px'
});

export const UploadProgressFileName = styled('span')({
    marginLeft: '8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexGrow: 1,
    color: colors.white
});

export const UploadProgressBarContainer = styled(Box)({
    width: '100%',
    flexGrow: 1,
    position: 'relative'
});

export const UploadProgressBar = styled(Box)({
    width: '100%',
    height: '4px',
    backgroundColor: '#20222D',
    borderRadius: '2px'
});

export const UploadProgressFill = styled(Box)<{ progress: number }>(({ progress }) => ({
    width: `${progress}%`,
    height: '100%',
    backgroundColor: colors.yellow,
    borderRadius: '2px',
    transition: 'width 0.3s ease'
}));

export const UploadProgressPercent = styled('span')({
    minWidth: '40px',
    textAlign: 'right',
    color: colors.yellow
});

export const UploadProgressCancelButton = styled(Box)({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '2px'
});

export const BlockerDialogDescription = styled(Typography)({
    color: colors.white,
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '10px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '500px'
});
